import { createSlice } from '@reduxjs/toolkit';

import { NotificationMessage } from 'components/notification-message/NotificationMessage';
import { Service } from 'services/Services';
import { RequestApi, RequestApiDisableHead } from 'RequestApi';

const initialState = {
  contacts: [],
  pageCount: 0,
  pageIndex: 0,
  loading: false,
  pageInfo: null,
  fetching: false,
  records: [],
  links: [],
  nextPageUrl: null,
  prevPageUrl: null,
  currentPage: 1,
  viewingRecord: null,
  progressingDocument: false,
};

const dynamicPageRecord2Slice = createSlice({
  name: 'dynamicPageRecord2',
  initialState,
  reducers: {
    receiveService(state, action) {
      const { records, links, nextPageUrl, prevPageUrl, currentPage } = action.payload;
      state.records = records;
      state.links = links;
      state.nextPageUrl = nextPageUrl;
      state.prevPageUrl = prevPageUrl;
      state.currentPage = currentPage;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    handleClickSearch(state, action) {
      state.loading = action.payload;
    },
    setPageInfo(state, action) {
      state.pageInfo = action.payload;
    },
    setFetching(state, action) {
      state.fetching = action.payload;
    },
    setViewingRecord(state, action) {
      state.viewingRecord = action.payload;
    },
    setProgressingDocument(state, action) {
      state.progressingDocument = action.payload;
    },
  },
});
const { setLoading, receiveService, setPageInfo, setFetching } = dynamicPageRecord2Slice.actions;

export const { setViewingRecord, setProgressingDocument } = dynamicPageRecord2Slice.actions;

// ----------- Start ------------ //

export const initPageInfo =
  ({ informationPage }) =>
  async (dispatch) => {
    dispatch(setPageInfo(informationPage));
  };

export const fetchRecords =
  ({ url, sortBy, searchText = '', startingDate = '', endingDate = '' }) =>
  async (dispatch) => {
    dispatch(setFetching(true));

    let urlRequest = `${url}/index-table?`;
    urlRequest += `auth_token=${Service.userToken}`;

    if (!sortBy) {
      sortBy = {
        id: 'updated_at',
        desc: true,
      };
    }

    const data = JSON.stringify({
      search_text_value: searchText,
      sort_field_name: sortBy.id,
      sort_direction: sortBy.desc ? 'desc' : 'asc',
      flag: '',
      search_starting_date: startingDate,
      search_ending_date: endingDate,
    });
    RequestApi(urlRequest, {
      data,
    })
      .then((res) => {
        if (res.status === 200) {
          if (res.data.status === 'success') {
            dispatch(
              receiveService({
                records: res.data.records.data,
                links: res.data.records.links,
                nextPageUrl: res.data.records.next_page_url,
                prevPageUrl: res.data.records.prev_page_url,
                currentPage: res.data.records.current_page,
              })
            );
          } else {
            NotificationMessage({ message: res.data.msg, status: res.data.status });
          }
        } else {
          NotificationMessage({ message: res.message, status: 'warning' });
        }
        dispatch(setFetching(false));
      })
      .catch((err) => {
        dispatch(setFetching(false));
        NotificationMessage({ message: err.toString(), status: 'error' });
      });
  };

export const goToPage =
  ({ url, startingDate = '', endingDate = '' }) =>
  async (dispatch) => {
    dispatch(setFetching(true));

    const data = JSON.stringify({
      flag: '',
      search_starting_date: startingDate,
      search_ending_date: endingDate,
    });

    RequestApiDisableHead(url, { data })
      .then((res) => {
        if (res.status === 200) {
          if (res.data.status === 'success') {
            dispatch(
              receiveService({
                records: res.data.records.data,
                links: res.data.records.links,
                nextPageUrl: res.data.records.next_page_url,
                prevPageUrl: res.data.records.prev_page_url,
                currentPage: res.data.records.current_page,
              })
            );
          } else {
            NotificationMessage({ message: res.data.msg, status: res.data.status });
          }
        } else {
          NotificationMessage({ message: res.message, status: 'warning' });
        }
        dispatch(setFetching(false));
      })
      .catch((err) => {
        dispatch(setFetching(false));
        NotificationMessage({ message: err.toString(), status: 'error' });
      });
  };

const dynamicPageRecord2Reducer = dynamicPageRecord2Slice.reducer;

export default dynamicPageRecord2Reducer;
